import React, { useEffect, useState } from "react";
import { Flame, Check } from "lucide-react";
import api from "../lib/api";

/* "2/3 stories this week" progress toward the weekly share-streak bonus spin. */
export const StreakProgressChip = ({ ta, refreshKey }) => {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/share/streak").then((r) => setS(r.data)).catch(() => {}); }, [refreshKey]);
  if (!s) return null;
  const done = s.awarded || s.week_shares >= s.streak_target;
  const left = Math.max(0, s.streak_target - s.week_shares);
  return (
    <div className={`flex items-center gap-2 rounded-2xl px-3 py-2 text-[11px] font-bold ${done ? "bg-emerald-50 text-emerald-800 border border-emerald-200" : "bg-orange-50 text-orange-800 border border-orange-200"}`} data-testid="streak-progress-chip" data-shares={s.week_shares}>
      {done ? <Check className="w-4 h-4" /> : <Flame className="w-4 h-4" />}
      <span className="flex-1">
        {done ? (ta ? "இந்த வாரம் Share streak bonus spin கிடைத்தது ✅" : "Share streak bonus spin earned this week ✅")
          : (ta ? `${s.week_shares}/${s.streak_target} stories இந்த வாரம் · இன்னும் ${left} share → Bonus spin` : `${s.week_shares}/${s.streak_target} stories this week · ${left} more → bonus spin`)}
      </span>
      <span className="flex gap-1" aria-hidden>
        {Array.from({ length: s.streak_target }).map((_, i) => <span key={i} className={`w-2 h-2 rounded-full ${i < Math.min(s.week_shares, s.streak_target) ? (done ? "bg-emerald-500" : "bg-orange-500") : "bg-slate-200"}`} />)}
      </span>
    </div>
  );
};
